import { render, staticRenderFns } from "./EDSAuthPanel.vue?vue&type=template&id=d3fbdafa"
import script from "./EDSAuthPanel.vue?vue&type=script&lang=js"
export * from "./EDSAuthPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports